import { useContext } from 'react';
import { TenantFeaturesContext } from '../Context/TenantFeatureContext';

export function CheckRiderEnabled() {
    const context = useContext(TenantFeaturesContext);
    if (context.tenantFeatures.length) {
        return context.tenantFeatures.some((f) => f.feature.name === 'RIDER_APPROVAL')
        }
    return false;
};

export function CheckDriverEnabled() {
    const context = useContext(TenantFeaturesContext);
    if (context.tenantFeatures.length) {
        return context.tenantFeatures.some((f) => f.feature.name === 'DRIVER_APPROVAL')
        }
    return false;
};

export function CheckCarPoolingEnabled() {
    const context = useContext(TenantFeaturesContext);
    if (context.tenantFeatures.length) {
        return context.tenantFeatures.some((f) => f.feature.name === 'CAR_POOLING')
        }
    return false;
};
